import React, { CSSProperties, ReactNode, useState } from 'react';
import DialogBase from '../../../base/DialogBase/DialogBase';
import { useGetTagTypesQuery, useGetTagListWithTypeQuery, useAssignProjectsTagsMutation } from '../../../generated/graphql';
import { FormAutoComplete } from '../../form';
import styles from './AddProjectsTagsDialog.module.css';

type AddProjectsTagsDialogProps = {
    onClose: () => void,
    ids: string[],
    visible: boolean,
    style?: CSSProperties | undefined,
    children?: ReactNode | undefined,
};

const AddProjectsTagsDialog = (props: AddProjectsTagsDialogProps) => {
    const { ids, style, visible, onClose } = props;
    const [tagType, setTagType] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [validationError, setValidationError] = useState('');
    const [assignProjectsTags, assignProjectsTagsResult] = useAssignProjectsTagsMutation();
    const types = useGetTagTypesQuery({ fetchPolicy: "no-cache" });
    const tags = useGetTagListWithTypeQuery({
        variables: { contains: searchTag, type: tagType }
    });

    const handleSubmit = () => {
        const selectedType = types.data?.TagTypes?.filter(l => l === tagType)[0];
        const selectedTag = tags.data?.TagList?.nodes?.filter(t => t?.name === searchTag)[0];

        if (!tagType || !searchTag) {
            setValidationError('Please fill all of the following fields.');
            return;
        }
        if (!selectedType) {
            setValidationError('Please Select A Valid Type!');
            return;
        }
        if (!selectedTag) {
            setValidationError('Please Select A Valid Tag!');
            return;
        }
        setValidationError('');
        const tagIds = tags.data?.TagList?.nodes?.filter(l => l?.name === searchTag).map(t => t?.id || "");
        assignProjectsTags({
            variables: { ids, tagIds }
        })
            .then(() => { onClose(); })
            .catch(() => {});
    };

    return (
        <DialogBase
            title="Assign Projects Tags"
            type="OkCancel"
            isLoading={assignProjectsTagsResult.loading}
            visible={visible}
            onClose={onClose}
            onSubmit={handleSubmit}
            validationError={validationError}
            className={styles.AddProjectsTagsDialog}
            style={style}
            data-testid="AddProjectsTagsDialog">
            <FormAutoComplete
                label="Tag Type"
                name="type"
                value={tagType}
                onChange={setTagType}
                options={(types.data?.TagTypes || []).filter((t): t is string => !!t)}
            />
            <FormAutoComplete
                label="Tag"
                name="tag"
                value={searchTag}
                onChange={setSearchTag}
                options={(tags.data?.TagList?.nodes?.map(p => p?.name) || []).filter((n): n is string => !!n)}
            />
        </DialogBase>
    );
};

export default AddProjectsTagsDialog;
